<template>
  <div id="main-settings-wrapper">
    <a-tabs default-active-key="1">
      <a-tab-pane
        v-if="status_license_main.condition != 'empty'"
        key="1"
        :tab="$t('accessMatrix')"
      >
        <a-form
          id="settings_main_form"
          :form="form_main"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 15 }"
          @submit="handleSubmit_main"
        >
          <a-form-item label="HR">
            <a-select
              mode="multiple"
              :placeholder="$t('employees')"
              show-search
              :filter-option="false"
              @search="(value) => searchUser(value, 'HR')"
              v-decorator="[
                'HR',
                {
                  rules: [{ required: false }],
                  initialValue: settingsUserData.HR || [],
                },
              ]"
            >
              <a-select-option
                v-for="employee in filterUserHR"
                :value="employee.ID"
                :key="employee.ID"
              >
                <a-avatar
                  v-if="employee.PERSONAL_PHOTO"
                  style="width: 24px; height: 24px; margin-bottom: 3px"
                  :src="employee.PERSONAL_PHOTO"
                />
                <a-avatar
                  v-else
                  style="
                    width: 20px;
                    height: 20px;
                    color: #f56a00;
                    background-color: #fde3cf;
                    margin-bottom: 3px;
                    line-height: 20px;
                    font-weight: 500;
                  "
                  >{{ employee.NAME ? employee.NAME[0] : "?" }}</a-avatar
                >
                {{ `${employee.LAST_NAME} ${employee.NAME}` }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Office">
            <a-select
              mode="multiple"
              :placeholder="$t('employees')"
              show-search
              :filter-option="false"
              @search="(value) => searchUser(value, 'Office')"
              v-decorator="[
                'Office',
                {
                  rules: [{ required: false }],
                  initialValue: settingsUserData.Office || [],
                },
              ]"
            >
              <a-select-option
                v-for="employee in filterUserOffice"
                :key="employee.ID"
              >
                <a-avatar
                  v-if="employee.PERSONAL_PHOTO"
                  style="width: 24px; height: 24px; margin-bottom: 3px"
                  :src="employee.PERSONAL_PHOTO"
                />
                <a-avatar
                  v-else
                  style="
                    width: 20px;
                    height: 20px;
                    color: #f56a00;
                    background-color: #fde3cf;
                    margin-bottom: 3px;
                    line-height: 20px;
                    font-weight: 500;
                  "
                  >{{ employee.NAME ? employee.NAME[0] : "?" }}</a-avatar
                >
                {{ `${employee.LAST_NAME} ${employee.NAME}` }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="CEO">
            <a-select
              mode="multiple"
              show-search
              :filter-option="false"
              @search="(value) => searchUser(value, 'CEO')"
              :placeholder="$t('employees')"
              v-decorator="[
                'CEO',
                {
                  rules: [{ required: false }],
                  initialValue: settingsUserData.CEO || [],
                },
              ]"
            >
              <a-select-option
                v-for="employee in filterUserCEO"
                :key="employee.ID"
              >
                <a-avatar
                  v-if="employee.PERSONAL_PHOTO"
                  style="width: 24px; height: 24px; margin-bottom: 3px"
                  :src="employee.PERSONAL_PHOTO"
                />
                <a-avatar
                  v-else
                  style="
                    width: 20px;
                    height: 20px;
                    color: #f56a00;
                    background-color: #fde3cf;
                    margin-bottom: 3px;
                    line-height: 20px;
                    font-weight: 500;
                  "
                  >{{ employee.NAME ? employee.NAME[0] : "?" }}</a-avatar
                >
                {{ `${employee.LAST_NAME} ${employee.NAME}` }}
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item wrapper-col="{ span: 24 }" style="text-align: center">
            <a-button type="primary" html-type="submit">{{
              $t("Zapisz")
            }}</a-button>
          </a-form-item>
        </a-form>
      </a-tab-pane>
      <a-tab-pane
        v-if="status_license_main.condition != 'empty'"
        key="2"
        :tab="$t('Setting up fields')"
        force-render
      >
        <a-form
          id="settings_сompany_form"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 15 }"
          :form="form_main"
          @submit="handleSubmit_company"
        >
          <a-form-item :label="$t('type company')">
            <a-select
              mode="multiple"
              v-decorator="[
                'companyTypes',
                {
                  rules: [{ required: false }],
                  initialValue: settingsUserData.companyTypes || [],
                },
              ]"
            >
              <a-select-option v-for="type in companyTypes" :key="type.ID">{{
                type.NAME
              }}</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item :label="$t('Absence type')">
            <a-select
              mode="tags"
              style="width: 100%"
              v-decorator="[
                'AbsenceType',
                {
                  rules: [{ required: false }],
                  initialValue: settingsUserData.AbsenceType || [],
                },
              ]"
            >
              <a-select-option
                v-for="type in settingsUserData.AbsenceType"
                :key="type"
                >{{ type }}</a-select-option
              >
            </a-select>
          </a-form-item>

          <a-form-item :label="$t('Vacation type')">
            <a-select
              mode="tags"
              style="width: 100%"
              v-decorator="[
                'AbsType',
                {
                  rules: [{ required: false }],
                  initialValue: settingsUserData.AbsType || [],
                },
              ]"
            >
              <a-select-option
                v-for="type in settingsUserData.AbsType"
                :key="type"
                >{{ type }}</a-select-option
              >
            </a-select>
          </a-form-item>

          <a-form-item :label="$t('Disk folder')">
            <a-select
              v-decorator="[
                'diskFolder',
                {
                  rules: [{ required: false }],
                  initialValue: settingsUserData.diskFolder || [],
                },
              ]"
            >
              <a-select-option v-for="folder in folders" :key="folder.ID">{{
                folder.NAME
              }}</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item :label="$t('Type of counting days')">
            <a-switch
              v-decorator="[
                'typeOfCountingDays',
                {
                  rules: [{ required: false }],
                },
              ]"
              :defaultChecked="
                settingsUserData.typeOfCountingDays == '0' ? false : true
              "
              :checked-children="$t('Work days')"
              :un-checked-children="$t('Calendar days')"
            />
          </a-form-item>

          <a-form-item :label="$t('Consider weekends')">
            <a-switch
              v-decorator="[
                'considerWeekendsAndHolidays',
                {
                  rules: [{ required: false }],
                },
              ]"
              :defaultChecked="
                settingsUserData.considerWeekendsAndHolidays == '0'
                  ? false
                  : true
              "
              :checked-children="$t('Yes')"
              :un-checked-children="$t('No')"
            />
          </a-form-item>

          <a-form-item wrapper-col="{ span: 24 }" style="text-align: center">
            <a-button type="primary" html-type="submit">{{
              $t("Zapisz")
            }}</a-button>
          </a-form-item>
        </a-form>
      </a-tab-pane>
      <a-tab-pane :key="3" :tab="$t('License')" force-render>
        <a-form
          :form="form_license"
          @submit="handleSubmit_license"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 15 }"
        >
          <a-row>
            <a-col style="text-align: center">
              <a-tooltip>
                <template slot="title">
                  {{ diffDays() + " " + $t("limit days") }}
                </template>
                <a-progress
                  v-if="status_license_main.condition == 'full'"
                  type="dashboard"
                  status="active"
                  :width="100"
                  :percent="(diffDays() * 100) / 365"
                  :format="() => diffDays() + ' ' + $t('days')"
                ></a-progress>
                <a-progress
                  v-if="status_license_main.condition == 'trial'"
                  type="dashboard"
                  status="active"
                  :width="100"
                  :percent="(diffDays() * 100) / 15"
                  :format="() => diffDays() + ' ' + $t('days')"
                ></a-progress>
              </a-tooltip>
              <p v-if="status_license_main.condition == 'full'">
                {{ $t("License period") }}
                <a-tag color="blue">365 {{ $t("days") }}</a-tag>
              </p>
              <p v-if="status_license_main.condition == 'trial'">
                {{ $t("Trial") }}
                <a-tag color="blue">15 {{ $t("days") }}</a-tag>
              </p>

              <a-form-item :label="$t('license')">
                <a-tooltip>
                  <template slot="title">{{ $t("license key") }}</template>
                  <a-input
                    :placeholder="$t('Enter license key')"
                    :disabled="status_license_main.condition == 'full'"
                    v-decorator="[
                      `licenseKey`,
                      {
                        rules: [{ required: false }],
                        initialValue:
                          status_license_main.condition == 'full'
                            ? license_settings.lic_key
                            : '',
                      },
                    ]"
                  ></a-input>
                </a-tooltip>
              </a-form-item>
            </a-col>
          </a-row>

          <a-form-item
            align="center"
            :label-col="{ span: 0 }"
            :wrapper-col="{ span: 24 }"
          >
            <a-button
              :disabled="license_settings.condition == 'full'"
              type="primary"
              html-type="submit"
              >{{ $t("Save") }}</a-button
            >
          </a-form-item>
        </a-form>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import { updateAuth, generateFormData } from "../requestFunc";
import moment from "moment";
export default {
  props: [
    "userInfo",
    "currentUserIdForEdit",
    "settingsUserData",
    "userAccess",
    "companyTypes",
    "license_settings",
    "status_license_main",
  ],
  data() {
    return {
      form_main: this.$form.createForm(this, { name: "set_main" }),
      form_license: this.$form.createForm(this, { name: "set_license" }),
      folders: [],
      filter: {
        HR: "",
        Office: "",
        CEO: "",
      },
    };
  },
  computed: {
    filterUserHR() {
      console.log("====", this.filter.HR);
      return this.filterUser(this.filter.HR);
    },
    filterUserOffice() {
      return this.filterUser(this.filter.Office);
    },
    filterUserCEO() {
      return this.filterUser(this.filter.CEO);
    },
  },
  methods: {
    moment,
    diffDays() {
      if (this.status_license_main.condition == "full")
        return moment(this.license_settings.lic_end_date).diff(
          moment(),
          "days"
        );
      if (this.status_license_main.condition == "trial")
        return moment(this.license_settings.trial_end_date).diff(
          moment(),
          "days"
        );
    },
    async handleSubmit_license(e) {
      e.preventDefault();

      let valuesForm = "";
      this.form_license.validateFields((err, values) => {
        valuesForm = values;
      });

      let url = "/php/request.php";

      const response = await fetch(url, {
        method: "POST",
        body: generateFormData({
          token: updateAuth().token,
          domain: updateAuth().domain,
          run: "savelicense",
          licensekey: valuesForm.licenseKey,
        }),
      });

      console.log(response);

      // let result = await response.json();

      // if (result) {
      //   this.$emit("setNewSettingsCompany", result.settings.companyTypes);
      //   this.$message.success(this.$t("Data recorded successfully"));
      // } else {
      //   this.$message.warning(this.$t("Data recorded error"));
      // }
    },
    async handleSubmit_company(e) {
      e.preventDefault();

      let valuesForm = {};
      this.form_main.validateFields((err, values) => {
        valuesForm = values;
      });

      let url = "/php/request.php";

      const response = await fetch(url, {
        method: "POST",
        body: generateFormData({
          token: updateAuth().token,
          domain: updateAuth().domain,
          run: "saveSettingsCompany",
          companyTypes: JSON.stringify(valuesForm),
        }),
      });

      let result = await response.json();

      if (result) {
        this.$emit("setNewSettingsCompany", result.settings.companyTypes);
        this.$message.success(this.$t("Data recorded successfully"));
      } else {
        this.$message.warning(this.$t("Data recorded error"));
      }
    },
    async handleSubmit_main(e) {
      e.preventDefault();

      let valuesForm = {};
      this.form_main.validateFields((err, values) => {
        valuesForm = values;
      });

      let url = "/php/request.php";

      const response = await fetch(url, {
        method: "POST",
        body: generateFormData({
          token: updateAuth().token,
          domain: updateAuth().domain,
          run: "saveSettings",
          data: JSON.stringify(valuesForm),
        }),
      });
      let result = await response.json();

      if (result) {
        this.$emit("setNewSettings", result.settings);
        this.$message.success(this.$t("Data recorded successfully"));
      } else {
        this.$message.warning(this.$t("Data recorded error"));
      }
    },
    searchUser(value, type) {
      this.filter[type] = value;
      console.log(this.filter, value, type, this.filterUserHR);
      this.filterUserHR;
    },
    filterUser(searchInput) {
      return this.userInfo
        .map((el, index) => ({ ...el, index }))
        .filter((el) => {
          return (
            (el.LAST_NAME + " " + el.NAME)
              .toLowerCase()
              .indexOf(searchInput.toLowerCase()) > -1
          );
        });
    },
  },
  mounted() {
    console.log(this.settingsUserData, "settingsUserData");
    BX24.callMethod(
      "disk.storage.getlist",
      {
        filter: {
          ENTITY_TYPE: "common",
        },
      },
      (result) => {
        if (result.error()) console.error(result.error());
        else {
          const folder = result.data()[0].ID;
          BX24.callMethod(
            "disk.storage.getchildren",
            {
              id: folder,
            },
            (result) => {
              if (result.error()) console.error(result.error());
              else {
                this.folders = result.data();
              }
            }
          );
        }
      }
    );

    // eslint-disable-next-line
    BX24.fitWindow();
  },
};
</script>

<style scoped>
#main-settings-wrapper .ant-list-header {
  background-color: blue;
  padding: 0px;
}
.ant-list-item {
  padding: 0;
}

#main-settings-wrapper {
  font-weight: 400;
  color: #000;
}

#main-settings-wrapper h2,
#main-settings-wrapper > .ant-card-head-title {
  font-weight: 500;
  color: #000;
}

#main-settings-wrapper .sett-select {
  font-size: 1rem;
}
.ant-btn-primary {
  color: #fff !important;
}
</style>
